import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  ar: {
    // Navigation
    home: 'الرئيسية',
    matches: 'المباريات',
    results: 'النتائج',
    standings: 'الترتيب',
    teams: 'الفرق',
    news: 'الأخبار',
    clubNews: 'أخبار الأندية',
    live: 'مباشر',
    statistics: 'الإحصائيات',
    calendar: 'الرزنامة',
    committees: 'اللجان',
    designations: 'التعيينات',
    statistics: 'الإحصائيات',
    admin: 'دخول الإدارة',
    logout: 'تسجيل الخروج',
    dashboard: 'لوحة التحكم',

    // Général
    season: 'الموسم',
    round: 'الجولة',
    team: 'فريق',
    played: 'لعب',
    won: 'فوز',
    draw: 'تعادل',
    lost: 'خسارة',
    goals: 'أهداف',
    points: 'النقاط',
    date: 'التاريخ',
    time: 'الوقت',
    venue: 'الملعب',
    city: 'المدينة',
    stadium: 'الملعب',

    // Statuts
    finished: 'انتهت',
    upcoming: 'قادمة',
    liveNow: 'مباشر الآن',
    watchLive: 'شاهد المباراة',

    // Sections
    latestResults: 'آخر النتائج',
    upcomingMatches: 'المباريات القادمة',
    allTeams: 'جميع الفرق',
    allMatches: 'جميع المباريات',
    topScorers: 'الهدافين',

    // Actions
    loading: 'جاري التحميل...',
    comingSoon: 'قريباً',
    viewAll: 'عرض الكل',
    share: 'مشاركة',
    download: 'تحميل',

    // Admin
    login: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    addTeam: 'إضافة فريق',
    editTeam: 'تعديل فريق',
    deleteTeam: 'حذف فريق',
    addMatch: 'إضافة مباراة',
    updateScore: 'تحديث النتيجة',
    save: 'حفظ',
    cancel: 'إلغاء',

    // Messages
    noData: 'لا توجد بيانات',
    error: 'حدث خطأ',
    success: 'تمت العملية بنجاح',

    // TopBar
    tunis: 'تونس، تونس',
    communiques: 'القوانين واللوائح',
    discipline: 'الانضباط',
    players: 'اللاعبين',
    settings: 'الإعدادات',
    overview: 'نظرة عامة',
    clubNews: 'أخبار الأندية',
    committees: 'اللجان',
    designations: 'التعيينات',
    ticker: 'شريط الأخبار',
    administration: 'الإدارة',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    laws: 'القوانين واللوائح',
    regulations: 'النظام الداخلي',
    about: 'عن الرابطة',
    media: 'ملتيميديا',
    usefulLinks: 'روابط مفيدة',
    gallery: 'معرض الصور',
    videos: 'الفيديوهات',
    photos: 'الصور',
    radio: 'لقاءات إذاعية',
    tv: 'لقاءات تلفزيونية',
    press: 'لقاءات صحفية',
    interviews: 'لقاءات'
  },
  fr: {
    // Navigation
    home: 'Accueil',
    matches: 'Matchs',
    results: 'Résultats',
    standings: 'Classement',
    teams: 'Équipes',
    news: 'Actualités',
    clubNews: 'Actualités des Clubs',
    live: 'En Direct',
    statistics: 'Statistiques',
    calendar: 'Calendrier',
    committees: 'Comités',
    designations: 'Désignations',
    statistics: 'Statistiques',
    admin: 'Administration',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',

    // Général
    season: 'Saison',
    round: 'Journée',
    team: 'Équipe',
    played: 'J',
    won: 'G',
    draw: 'N',
    lost: 'P',
    goals: 'Buts',
    points: 'Pts',
    date: 'Date',
    time: 'Heure',
    venue: 'Stade',
    city: 'Ville',
    stadium: 'Stade',

    // Statuts
    finished: 'Terminé',
    upcoming: 'À venir',
    liveNow: 'En Direct',
    watchLive: 'Regarder',

    // Sections
    latestResults: 'Derniers Résultats',
    upcomingMatches: 'Prochains Matchs',
    allTeams: 'Toutes les Équipes',
    allMatches: 'Tous les Matchs',
    topScorers: 'Meilleurs Buteurs',

    // Actions
    loading: 'Chargement...',
    comingSoon: 'Bientôt disponible',
    viewAll: 'Voir tout',
    share: 'Partager',
    download: 'Télécharger',

    // Admin
    login: 'Connexion',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    addTeam: 'Ajouter une équipe',
    editTeam: 'Modifier une équipe',
    deleteTeam: 'Supprimer une équipe',
    addMatch: 'Ajouter un match',
    updateScore: 'Mettre à jour le score',
    save: 'Enregistrer',
    cancel: 'Annuler',

    // Messages
    noData: 'Aucune donnée',
    error: 'Une erreur est survenue',
    success: 'Opération réussie',

    // TopBar
    tunis: 'Tunis, Tunisie',
    communiques: 'Lois et Règlements',
    discipline: 'Discipline',
    players: 'Joueurs',
    settings: 'Paramètres',
    overview: 'Vue d\'ensemble',
    clubNews: 'Actualités Clubs',
    committees: 'Comités',
    designations: 'Désignations',
    ticker: 'Barre Info',
    administration: 'Administration',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    laws: 'Lois et Règlements',
    regulations: 'Règlement Intérieur',
    about: 'À Propos',
    media: 'Espace Média',
    usefulLinks: 'Infos utiles',
    gallery: 'Galerie Photos',
    videos: 'Vidéos',
    photos: 'Photos',
    radio: 'Interviews Radio',
    tv: 'Interviews TV',
    press: 'Interviews Presse',
    interviews: 'Interviews'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Récupérer la langue sauvegardée ou utiliser 'ar' par défaut
    return localStorage.getItem('language') || 'ar';
  });

  const t = (key) => {
    if (!translations[language]) return key;
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => {
      const newLang = prev === 'ar' ? 'fr' : 'ar';
      localStorage.setItem('language', newLang);
      return newLang;
    });
  };

  // Appliquer la direction au body
  useEffect(() => {
    document.body.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.body.style.fontFamily = language === 'ar'
      ? "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      : "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
    document.body.style.letterSpacing = '0';
    document.body.style.wordSpacing = '0';
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
